import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Container } from './Template.style';

export interface ITemplate {
  children: React.ReactNode;
}

export const Template: React.FC<ITemplate> = ({ children }) => {
  return (
    <Container>
      <Header />
      {children}
      <Footer />
    </Container>
  );
};
